import { render } from "./ContentSwiperStackEditorCmp.vue?vue&type=template&id=1436e7bc"
import script from "./ContentSwiperStackEditorCmp.vue?vue&type=script&lang=js"
export * from "./ContentSwiperStackEditorCmp.vue?vue&type=script&lang=js"

import "./ContentSwiperStackEditorCmp.vue?vue&type=style&index=0&id=1436e7bc&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__